import { appConfig } from './app';

export const QRCODE_SLOT_PREFIX = `${appConfig.company}://slot/`;
export const QRCODE_LOCATION_PREFIX = `${appConfig.company}://location/`;
export const QRCODE_SPACE_PREFIX = `${appConfig.company}://space/`;
